import { Injectable } from '@angular/core';
import * as Excel from "exceljs/dist/exceljs.min.js";
import * as FileSaver from 'file-saver';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelPowersupplyCertificationListService {
constructor(){}
public exportAsExcelFile(json: any[], excelFileName: string) {
  const workbook = new Excel.Workbook;
  workbook.addWorksheet(excelFileName);
  const sheet = workbook.getWorksheet(1);
  sheet.columns = this.getHeaders();
  sheet.addRows(json);
  sheet.eachRow(function (row, rowNumber) {
    row.eachCell({ includeEmpty: true }, function (cell) {
      if (rowNumber === 1) {
        sheet.getCell(cell.address.toString()).fill = {
          type: 'gradient', gradient: 'angle', degree: 0, stops: [
            { position: 0, color: { argb: 'd9f1fa' } },
            { position: 0.5, color: { argb: 'd9f1fa' } },
            { position: 1, color: { argb: 'd9f1fa' } }
          ]
        };
        sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
        sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
        sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8, bold: 'true' };
      } else {
        sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
        sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8 };
        sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
      }
    });
  });
  workbook.xlsx.writeBuffer().then(data => {
    const blob = new Blob([data], { type: EXCEL_TYPE });
    FileSaver.saveAs(blob, excelFileName + EXCEL_EXTENSION);
  })
  return false;
}
getHeaders(){
let wchpsCertificationId=20;
let wchhouseNumber=20;
let wchstreetNumber=20;
let wchcrossStreet=20;
let wchcity=20;
let wchstate=20;
let wchzip=20;
let wchgpsLongitude=20;
let wchgpsLatitude=20;
let wchpowersNode=20;
let wchpoleNumber=20;
let wchaerialUnderground=20;
let wchlocationComments=20;
let wchpowerSupplyType=20;
let wchmacAddress=20;
let wchmacAddressPrevious=20;
let wchip=20;
let wchtransponderVendor=20;
let wchtransponderModel=20;
let wchpowerSupplyNumber=20;
let wchacInputVoltage=20;
let wchoutputVoltage=20;
let wchinputCurrent=20;
let wchcurrentAmpOutput=20;
let wchpsAlertProfile=40;
let wchserialNumber=20;
let wchdcReady=20;
let wchcontrollerCardType=20;
let wchpriority=20;
let wchegisName=20;
let wchtransponderComments=20;
let wchpowerSupplyName=33;
let wchnumberOfBatteries=20;
let wchbatteriesReplaced=20;
//let wchairTemperature=20;
let wchbatteryBalancerString=30;
let wchtype11=20;
let wchtype12=20;
let wchtype13=20;
let wchtype14=20;
let wchtype21=20;
let wchtype22=20;
let wchtype23=20;
let wchtype24=20;
let wchtype31=20;
let wchtype32=20;
let wchtype33=20;
let wchtype34=20;
let wchtype41=20;
let wchtype42=20;
let wchtype43=20;
let wchtype44=20;
let wchtype51=20;
let wchtype52=20;
let wchtype53=20;
let wchtype54=20;
let wchtype61=20;
let wchtype62=20;
let wchtype63=20;
let wchtype64=20;
let wchmanufactureDate11=20;
let wchmanufactureDate12=20;
let wchmanufactureDate13=20;
let wchmanufactureDate14=20;
let wchmanufactureDate21=20;
let wchmanufactureDate22=20;
let wchmanufactureDate23=20;
let wchmanufactureDate24=20;
let wchmanufactureDate31=20;
let wchmanufactureDate32=20;
let wchmanufactureDate33=20;
let wchmanufactureDate34=20;
let wchmanufactureDate41=20;
let wchmanufactureDate42=20;
let wchmanufactureDate43=20;
let wchmanufactureDate44=20;
let wchmanufactureDate51=20;
let wchmanufactureDate52=20;
let wchmanufactureDate53=20;
let wchmanufactureDate54=20;
let wchmanufactureDate61=20;
let wchmanufactureDate62=20;
let wchmanufactureDate63=20;
let wchmanufactureDate64=20;
let wchinstallDate11=20;
let wchinstallDate12=20;
let wchinstallDate13=20;
let wchinstallDate14=20;
let wchinstallDate21=20;
let wchinstallDate22=20;
let wchinstallDate23=20;
let wchinstallDate24=20;
let wchinstallDate31=20;
let wchinstallDate32=20;
let wchinstallDate33=20;
let wchinstallDate34=20;
let wchinstallDate41=20;
let wchinstallDate42=20;
let wchinstallDate43=20;
let wchinstallDate44=20;
let wchinstallDate51=20;
let wchinstallDate52=20;
let wchinstallDate53=20;
let wchinstallDate54=20;
let wchinstallDate61=20;
let wchinstallDate62=20;
let wchinstallDate63=20;
let wchinstallDate64=20;
let wchvoltage11=20;
let wchvoltage12=20;
let wchvoltage13=20;
let wchvoltage14=20;
let wchvoltage21=20;
let wchvoltage22=20;
let wchvoltage23=20;
let wchvoltage24=20;
let wchvoltage31=20;
let wchvoltage32=20;
let wchvoltage33=20;
let wchvoltage34=20;
let wchvoltage41=20;
let wchvoltage42=20;
let wchvoltage43=20;
let wchvoltage44=20;
let wchvoltage51=20;
let wchvoltage52=20;
let wchvoltage53=20;
let wchvoltage54=20;
let wchvoltage61=20;
let wchvoltage62=20;
let wchvoltage63=20;
let wchvoltage64=20;
let wchbatteryVoltageUnderload11=20;
let wchbatteryVoltageUnderload12=20;
let wchbatteryVoltageUnderload13=20;
let wchbatteryVoltageUnderload14=20;
let wchbatteryVoltageUnderload21=20;
let wchbatteryVoltageUnderload22=20;
let wchbatteryVoltageUnderload23=20;
let wchbatteryVoltageUnderload24=20;
let wchbatteryVoltageUnderload31=20;
let wchbatteryVoltageUnderload32=20;
let wchbatteryVoltageUnderload33=20;
let wchbatteryVoltageUnderload34=20;
let wchbatteryVoltageUnderload41=20;
let wchbatteryVoltageUnderload42=20;
let wchbatteryVoltageUnderload43=20;
let wchbatteryVoltageUnderload44=20;
let wchbatteryVoltageUnderload51=20;
let wchbatteryVoltageUnderload52=20;
let wchbatteryVoltageUnderload53=20;
let wchbatteryVoltageUnderload54=20;
let wchbatteryVoltageUnderload61=20;
let wchbatteryVoltageUnderload62=20;
let wchbatteryVoltageUnderload63=20;
let wchbatteryVoltageUnderload64=20;
let wchbatteryConductance11=20;
let wchbatteryConductance12=20;
let wchbatteryConductance13=20;
let wchbatteryConductance14=20;
let wchbatteryConductance21=20;
let wchbatteryConductance22=20;
let wchbatteryConductance23=20;
let wchbatteryConductance24=20;
let wchbatteryConductance31=20;
let wchbatteryConductance32=20;
let wchbatteryConductance33=20;
let wchbatteryConductance34=20;
let wchbatteryConductance41=20;
let wchbatteryConductance42=20;
let wchbatteryConductance43=20;
let wchbatteryConductance44=20;
let wchbatteryConductance51=20;
let wchbatteryConductance52=20;
let wchbatteryConductance53=20;
let wchbatteryConductance54=20;
let wchbatteryConductance61=20;
let wchbatteryConductance62=20;
let wchbatteryConductance63=20;
let wchbatteryConductance64=20;
let wchbatteryConductanceCorrected11=20;
let wchbatteryConductanceCorrected12=20;
let wchbatteryConductanceCorrected13=20;
let wchbatteryConductanceCorrected14=20;
let wchbatteryConductanceCorrected21=20;
let wchbatteryConductanceCorrected22=20;
let wchbatteryConductanceCorrected23=20;
let wchbatteryConductanceCorrected24=20;
let wchbatteryConductanceCorrected31=20;
let wchbatteryConductanceCorrected32=20;
let wchbatteryConductanceCorrected33=20;
let wchbatteryConductanceCorrected34=20;
let wchbatteryConductanceCorrected41=20;
let wchbatteryConductanceCorrected42=20;
let wchbatteryConductanceCorrected43=20;
let wchbatteryConductanceCorrected44=20;
let wchbatteryConductanceCorrected51=20;
let wchbatteryConductanceCorrected52=20;
let wchbatteryConductanceCorrected53=20;
let wchbatteryConductanceCorrected54=20;
let wchbatteryConductanceCorrected61=20;
let wchbatteryConductanceCorrected62=20;
let wchbatteryConductanceCorrected63=20;
let wchbatteryConductanceCorrected64=20;
let wchtotalVoltageString11=20;
let wchtotalVoltageString12=20;
let wchtotalVoltageString21=20;
let wchtotalVoltageString22=20;
let wchtotalVoltageString31=20;
let wchtotalVoltageString32=20;
let wchtotalVoltageString41=20;
let wchtotalVoltageString42=20;
let wchtotalVoltageString51=20;
let wchtotalVoltageString52=20;
let wchtotalVoltageString53=20;
let wchtotalVoltageString54=20;
let wchtotalVoltageString61=20;
let wchtotalVoltageString62=20;
let wchtotalVoltageString63=20;
let wchtotalVoltageString64=20;
let wchbatteryString1Fused=20;
let wchbatteryString2Fused=20;
let wchbatteryString3Fused=20;
let wchbatteryString4Fused=20;
let wchbatteryString5Fused=20;
let wchbatteryString6Fused=20;
let wchbatteryComments=20;
let wchselftestverified=20;
let wchselfteststart=20;
let wchselftestend=20;
let wchapuMakeModel=20;
let wchapuSerialNumber=20;
let wchapuDeviceId=20;
let wchapuRunTime=20;
let wchecmAcm=20;
let wchdateApuInstalledValue=20;
let wchapuOutputVoltageRating=20;
let wchapuNoLoadVoltage=20;
let wchapuEnclosureMake=20;
let wchngLp=20;
let wchngProvider=20;
let wchlpTankCapacity=20;
let wchnumberTanksInstalled=20;
let wchinspectionDatelastvisit=20;
let wchtypeofvisit=40;
let wchvisitStatus=20;
let wchfollowUpReason=20;
let wchcleanEnclosure=20;
let wchtightenHardware=20;
let wchinspectConnectors=20;
let wchinspectProbes=20;
let wchmeterPanCondition=20;
let wchpowerCoRiserCondition=20;
let wchbatteryHeaterMatType=30;
let wchbatteryHeaterMatQuantity=20;
let wchenclosureSnowShield=20;
let wchinternalBreaker=20;
let wchserviceEntrance=20;
let wchreceptacleType=20;
let wchcheckSeizureAltBox=20;
let wchpowerSupplyIdLegible=20;
let wchcheckLampsLeds=20;
let wchcheckMagneticBreaker=20;
let wchvisualCabinetInspection=20;
let wchcabinetLocked=20;
let wchcheckGroundCabinet=20;
let wchtamperInstalledFunctioning=20;
let wchcheckLaps=20;
let wchcabinetVendor=20;
let wchcabinetBatteryCapacity=20;
let wchcheckOperatingLights=20;
let wchstandByOperation=20;
let wchfollowUpNeeded=20;
let wchinputSurgeArrestor=20;
let wchoutputSurgeArrestor=20;
let wchcoaxTvssPresent=20;
let wchacIndicatorGreenLight=20;
let wchlocalRemoteIndicator=20;
let wchcommTech=20;
let wchtechnicianNumber=20;
let wchinspectionDateValue=20;
let wchtechnicianNtUserName=20;
let wchapuBatteryManufacturerType=20;
let wchapuBatteryInstallDateValue=20;
let wchapuBatteryVoltageNoLoad=20;
let wchapuBatteryConductance=20;
let wchapuBatteryConductanceCrrctd=20;
let wchapuBatteryTorque=20;
let wchapuBatteryTerminalsCleaned=20;
let wchapuStarterBatteryChrgrVlt=20;
let wchapuChargerCurrentAmps=20;
let wchrecordAsFoundAlarms=20;
let wchapuTestRun=20;
let wchcheckOilLevel=20;
let wchoilAddedAmount=20;
let wchoilFilterTight=20;
let wchinspectGeneratorAirFilter=20;
let wchinspectSparkPlug=20;
let wcheventLogCleared=20;
let wchapuFrequency=20;
let wchtankOneLevel=20;
let wchtankTwoLevel=20;
let wchgasMeterNumber=20;
let wchgasMeterReading=20;
let wchngPressure=20;
let wchchangeCleanenClosureAirFilter=20;
let wchcheckForRodentDamage=20;
let wchcheckLampsLed=20;
let wchclearWeeds=20;
let wchcheckRegroutPadConduit=20;
let wchgroundMountPadUndermining=20;
let wchenclosureDamageVandalism=20;
let wchcleanupGarbage=20;
let wchtestOilPressureAlarm=20;
let wchtestHighTempAlarm=20;
let wchgeneratorDcBusFunction=20;
let wchcheckForGasLeaks=20;
let wchtestCombustibleGasAlarm=20;
let wchtestTamperAlarm=20;
let wchtestWaterIntrusionAlarm=20;
let wchtestPadShearAlarm=20;
let wchapuVisitComments=20;
let wchwrkitem=20;
let wchqnty=20;
let wchpartnmbr=20;
let wchalertLevel=20;
let wchwarning=20;
let wchinformational=20;
let wchtechnicianName=20;
let wchsysDescr=110;
let wchdocsDevServerConfigFile=20;
let wchdocsDevSwCurrentVers=20;
let wchpsConnectedCount=20;
let wchinputVoltageSupport=20;
let wchinputCurrentSupport=20;
let wchinputPowerSupport=20;
let wchpsOutputFrequencySupport=20;
let wchbootfile=30;
let wchphotouploadeddate=33;
let wchcertificationDate=20;
let wchpowerCompanyContactNumber = 20;
let wchpowerCompanyWebsite = 20;
let wchsubmittedBy=20;
let wchpowerSupplyId=20;
let wchpowerSupplyAddress=20;
let wchpowerSupplyVendor=20;
let wchpowerSupplyModel=20;
let wchisActive=20;
let wchfeedsMultipleNodes=20;
let wchmapNumber=20;
let wchnwtTeam=20;
let wchnitroCompletionDate=20;
let wchnitroReasonNotCompleted=20;
let wchxocVerified=20;
let wchsecurityBarPresent=20;
let wchstring11=20;
let wchbattery11=20;
let wchvoltage11hdn=20;
let wchnodesServed=20;
let wchpowerSupplyManualLink=20;
let wchpowerSupplyMessageBox=20;
let wchpowerSupplyAttachmentLinks=20;
let wchlogNt=20;
let wchlogName=20;
let wchlogDate=20;
let wchtemperature=20;
let wchshowActualLocation=20;
let wchutilityProvider=20;
let wchelectricMeterNumber=20;
let wchelectricMeterReading=20;
let wchrunEvents=20;
let wchrunMinutes=20;
let wchresetEventCounter=20;
let wchoutputCurrent=20;
let wchsoftwareVersion=20;
let wchoriginalTransponderNumber=20;
let wchreplacedTransponderNumber=20;
let wchvoltageUnderTotal=20;
let wchvoltageNoLoadTotal=20;
let wchcabinetType=20;
let wchcomments=20;
let wchdateEntered=20;
let wchvoltageUnderLoadTotalString=20;
let wchvoltageNoLoadTotalString=20;
let wchbatteryReplacementDate=20;
let wchmiscellaneous=20;
let wchsysLocation=54;
let wchsysContact=33;
let wchstring12=20;
let wchbattery12=20;
let wchstring13=20;
let wchbattery13=20;
let wchstring14=20;
let wchbattery14=20;
let wchstring21=20;
let wchbattery21=20;
let wchstring22=20;
let wchbattery22=20;
let wchstring23=20;
let wchbattery23=20;
let wchstring24=20;
let wchbattery24=20;
let wchstring31=20;
let wchbattery31=20;
let wchstring32=20;
let wchbattery32=20;
let wchstring33=20;
let wchbattery33=20;
let wchstring34=20;
let wchbattery34=20;
let wchalertProfileException=33;
let wchpowerSupplyType9360=20;
let wchtransponderOnline=20;
let wchapiResults=20;
let wchvoltage12hdn=20;
let wchvoltage13hdn=20;
let wchvoltage14hdn=20;
let wchvoltage21hdn=20;
let wchvoltage22hdn=20;
let wchvoltage23hdn=20;
let wchvoltage24hdn=20;
let wchvoltage31hdn=20;
let wchvoltage32hdn=20;
let wchvoltage33hdn=20;
let wchvoltage34hdn=20;
let wchhasBatteryBalancer=20;
let wchfiberDeep=20;
let wchalphaAppsCardInstalled=20;
let wchcpnDateCode=20;
let wchfirmwareVersion=20;
let wchoutputCurrentAmps1=20;
let wchoutputCurrentAmps2=20;
let wchpimAlphaDocInstalled=20;
let wchpowerSupplyEventCount=20;
let wchpowerSupplyEventTime=20;
let wchtotalRunDays=20;
let wchremoteStandbyOperation2=20;
let wchremoteStandbyOperation3=20;
let wchremoteStandbyOperation4=20;
let wchremoteStandbyOperation5=20;
let wchedfa=20;
let wchrefurbDate=20;
let wchcreatedDate=20;
let wchprevNodeServed=20;
let wchstring61=20;
let wchbattery61=20;
let wchvoltage61hdn=20;
let wchstring62=20;
let wchbattery62=20;
let wchvoltage62hdn=20;
let wchstring63=20;
let wchbattery63=20;
let wchvoltage63hdn=20;
let wchstring64=20;
let wchbattery64=20;
let wchvoltage64hdn=20;
let wchstring51=20;
let wchbattery51=20;
let wchvoltage51hdn=20;
let wchstring52=20;
let wchbattery52=20;
let wchvoltage52hdn=20;
let wchstring53=20;
let wchbattery53=20;
let wchvoltage53hdn=20;
let wchstring54=20;
let wchbattery54=20;
let wchvoltage54hdn=20;
let wchapuId=20;
let wchapuCompletedBy=20;
let wchswRev=33;
let wchhwRev=20;
let wchconfigFile=20;
let wchbootR=20;
let wchsysName=30;
let wchcalculatedRuntime=20;
let wchspecialLocationDetails=20;
let wchcompanyAccountNumber=20;
let wchpowerAccountType=20;
let wchbusinessPartnerRestriction=20;
let wchnextGenNode=20;
let wchapuLoadVoltage=20;
let wchfollowUpNeededAPU=20;
let wchstatus=20;
let wchtestduration=20;
let wchteststartdate=20;
let wchtestenddate=20;
let wchexternalSensor = 20;

let wchmaterialType=20;
let wchmodelDescription=20;
let wchmodel=20;
let wchquantity=20;

return [
  { header: 'CertID', key: 'psCertificationId',  width:wchpsCertificationId},
  { header:'CertificationDate', key:'certificationDateValue',width:wchcertificationDate},
  { header:'Status', key:'status',width:wchstatus},
  //Location Info
  { header: 'House Number', key: 'houseNumber',  width:wchhouseNumber},
  { header: 'Street', key: 'streetNumber',  width:wchstreetNumber},
  { header: 'Cross Street', key: 'crossStreet',  width:wchcrossStreet},
  { header: 'City', key: 'city',  width:wchcity},
  { header: 'State', key: 'state',  width:wchstate},
  { header: 'Zip', key: 'zip',  width:wchzip},
  { header: 'GPS Latitude', key: 'gpsLatitude',  width:wchgpsLongitude},
  { header: 'GPS Longitude', key: 'gpsLongitude',  width:wchgpsLatitude},
  { header: 'Calculated Runtime(in Minutes)', key: 'calculatedRuntime',  width:wchcalculatedRuntime},
  { header: 'Powers Node', key: 'powersNode',  width:wchpowersNode},
  { header: 'Pole#', key: 'poleNumber',  width:wchpoleNumber},
  { header: 'Underground/Aerial', key: 'aerialUnderground',  width:wchaerialUnderground},
  { header: 'Location Comments', key: 'locationComments',  width:wchlocationComments},

  //Transponder Info
  { header: 'Power Supplyname', key: 'powerSupplyName',  width:wchpowerSupplyName},
  { header: 'Power Supply type', key: 'powerSupplyType',  width:wchpowerSupplyType},
  { header: 'Mac address', key: 'macAddress',  width:wchmacAddress},
  { header: 'Previous Mac Address', key: 'macAddressPrevious',  width:wchmacAddressPrevious},
  { header: 'IP', key: 'ip',  width:wchip},
  { header: 'PS Company Contact Number', key: 'companyContact',  width:wchpowerCompanyContactNumber},
  { header: 'PS Company Website', key: 'companyWebsite',  width:wchpowerCompanyWebsite},
  { header: 'PS Number', key: 'powerSupplyNumber',  width:wchpowerSupplyNumber},
  { header: 'PS Model', key: 'powerSupplyModel',  width:wchpowerSupplyModel},
  { header: 'AC Input voltage rating', key: 'acInputVoltage',  width:wchacInputVoltage},
  { header: 'AC Output voltage rating', key: 'outputVoltage',  width:wchoutputVoltage},
  { header: 'Current Amp rating', key: 'inputCurrent',  width:wchinputCurrent},
  { header: 'current Amp (Output rating)', key: 'currentAmpOutput',  width:wchcurrentAmpOutput},
  { header: 'AlertProfile', key: 'psAlertProfile',  width:wchpsAlertProfile},
  { header: 'SerialNumber', key: 'serialNumber',  width:wchserialNumber},
  { header: 'DC Ready', key: 'dcReady',  width:wchdcReady},
  //{ header: 'Controller Card Type', key: 'controllerCardType',  width:wchcontrollerCardType},
  { header: 'Priority', key: 'priority',  width:wchpriority},
  { header: 'EGIS Number', key: 'egisName',  width:wchegisName},
  { header: 'Transponder Vendor', key: 'transponderVendor',  width:wchtransponderVendor},
  { header: 'Transponder Model', key: 'transponderModel',  width:wchtransponderModel},
  { header: 'Transponder comments', key: 'transponderComments',  width:wchtransponderComments},

  //Battery Info
  { header: 'Number of Batteries', key: 'numberOfBatteries',  width:wchnumberOfBatteries},
  { header: 'Batteries Replaced?', key: 'batteriesReplaced',  width:wchbatteriesReplaced},
  //{ header: 'Air Temperature', key: 'airTemperature',  width:wchairTemperature},
  { header: 'Battery Manager Model String', key: 'batteryBalancerString',  width:wchbatteryBalancerString},
  { header: 'Battery Manufacturer type Str1 Bat1', key: 'type11',  width:wchtype11},
  { header: 'Battery Manufacturer type Str1 Bat2', key: 'type12',  width:wchtype12},
  { header: 'Battery Manufacturer type Str1 Bat3', key: 'type13',  width:wchtype13},
  { header: 'Battery Manufacturer type Str1 Bat4', key: 'type14',  width:wchtype14},
  { header: 'Battery Manufacturer type Str2 Bat1', key: 'type21',  width:wchtype21},
  { header: 'Battery Manufacturer type Str2 Bat2', key: 'type22',  width:wchtype22},
  { header: 'Battery Manufacturer type Str2 Bat3', key: 'type23',  width:wchtype23},
  { header: 'Battery Manufacturer type Str2 Bat4', key: 'type24',  width:wchtype24},
  { header: 'Battery Manufacturer type Str3 Bat1', key: 'type31',  width:wchtype31},
  { header: 'Battery Manufacturer type Str3 Bat2', key: 'type32',  width:wchtype32},
  { header: 'Battery Manufacturer type Str3 Bat3', key: 'type33',  width:wchtype33},
  { header: 'Battery Manufacturer type Str3 Bat4', key: 'type34',  width:wchtype34},
  { header: 'Battery Manufacturer type Str4 Bat1', key: 'type41',  width:wchtype41},
  { header: 'Battery Manufacturer type Str4 Bat2', key: 'type42',  width:wchtype42},
  { header: 'Battery Manufacturer type Str4 Bat3', key: 'type43',  width:wchtype43},
  { header: 'Battery Manufacturer type Str4 Bat4', key: 'type44',  width:wchtype44},
  { header: 'Battery Manufacturer type Str5 Bat1', key: 'type51',  width:wchtype51},
  { header: 'Battery Manufacturer type Str5 Bat2', key: 'type52',  width:wchtype52},
  { header: 'Battery Manufacturer type Str5 Bat3', key: 'type53',  width:wchtype53},
  { header: 'Battery Manufacturer type Str5 Bat4', key: 'type54',  width:wchtype54},
  { header: 'Battery Manufacturer type Str6 Bat1', key: 'type61',  width:wchtype61},
  { header: 'Battery Manufacturer type Str6 Bat2', key: 'type62',  width:wchtype62},
  { header: 'Battery Manufacturer type Str6 Bat3', key: 'type63',  width:wchtype63},
  { header: 'Battery Manufacturer type Str6 Bat4', key: 'type64',  width:wchtype64},
  { header: 'Battery Date Code Str1 Bat1', key: 'manufactureDate11',  width:wchmanufactureDate11},
  { header: 'Battery Date Code Str1 Bat2', key: 'manufactureDate12',  width:wchmanufactureDate12},
  { header: 'Battery Date Code Str1 Bat3', key: 'manufactureDate13',  width:wchmanufactureDate13},
  { header: 'Battery Date Code Str1 Bat4', key: 'manufactureDate14',  width:wchmanufactureDate14},
  { header: 'Battery Date Code Str2 Bat1', key: 'manufactureDate21',  width:wchmanufactureDate21},
  { header: 'Battery Date Code Str2 Bat2', key: 'manufactureDate22',  width:wchmanufactureDate22},
  { header: 'Battery Date Code Str2 Bat3', key: 'manufactureDate23',  width:wchmanufactureDate23},
  { header: 'Battery Date Code Str2 Bat4', key: 'manufactureDate24',  width:wchmanufactureDate24},
  { header: 'Battery Date Code Str3 Bat1', key: 'manufactureDate31',  width:wchmanufactureDate31},
  { header: 'Battery Date Code Str3 Bat2', key: 'manufactureDate32',  width:wchmanufactureDate32},
  { header: 'Battery Date Code Str3 Bat3', key: 'manufactureDate33',  width:wchmanufactureDate33},
  { header: 'Battery Date Code Str3 Bat4', key: 'manufactureDate34',  width:wchmanufactureDate34},
  { header: 'Battery Date Code Str4 Bat1', key: 'manufactureDate41',  width:wchmanufactureDate41},
  { header: 'Battery Date Code Str4 Bat2', key: 'manufactureDate42',  width:wchmanufactureDate42},
  { header: 'Battery Date Code Str4 Bat3', key: 'manufactureDate43',  width:wchmanufactureDate43},
  { header: 'Battery Date Code Str4 Bat4', key: 'manufactureDate44',  width:wchmanufactureDate44},
  { header: 'Battery Date Code Str5 Bat1', key: 'manufactureDate51',  width:wchmanufactureDate51},
  { header: 'Battery Date Code Str5 Bat2', key: 'manufactureDate52',  width:wchmanufactureDate52},
  { header: 'Battery Date Code Str5 Bat3', key: 'manufactureDate53',  width:wchmanufactureDate53},
  { header: 'Battery Date Code Str5 Bat4', key: 'manufactureDate54',  width:wchmanufactureDate54},
  { header: 'Battery Date Code Str6 Bat1', key: 'manufactureDate61',  width:wchmanufactureDate61},
  { header: 'Battery Date Code Str6 Bat2', key: 'manufactureDate62',  width:wchmanufactureDate62},
  { header: 'Battery Date Code Str6 Bat3', key: 'manufactureDate63',  width:wchmanufactureDate63},
  { header: 'Battery Date Code Str6 Bat4', key: 'manufactureDate64',  width:wchmanufactureDate64},
  { header: 'Battery Install Date Str1 Bat1', key: 'installDate11',  width:wchinstallDate11},
  { header: 'Battery Install Date Str1 Bat2', key: 'installDate12',  width:wchinstallDate12},
  { header: 'Battery Install Date Str1 Bat3', key: 'installDate13',  width:wchinstallDate13},
  { header: 'Battery Install Date Str1 Bat4', key: 'installDate14',  width:wchinstallDate14},
  { header: 'Battery Install Date Str2 Bat1', key: 'installDate21',  width:wchinstallDate21},
  { header: 'Battery Install Date Str2 Bat2', key: 'installDate22',  width:wchinstallDate22},
  { header: 'Battery Install Date Str2 Bat3', key: 'installDate23',  width:wchinstallDate23},
  { header: 'Battery Install Date Str2 Bat4', key: 'installDate24',  width:wchinstallDate24},
  { header: 'Battery Install Date Str3 Bat1', key: 'installDate31',  width:wchinstallDate31},
  { header: 'Battery Install Date Str3 Bat2', key: 'installDate32',  width:wchinstallDate32},
  { header: 'Battery Install Date Str3 Bat3', key: 'installDate33',  width:wchinstallDate33},
  { header: 'Battery Install Date Str3 Bat4', key: 'installDate34',  width:wchinstallDate34},
  { header: 'Battery Install Date Str4 Bat1', key: 'installDate41',  width:wchinstallDate41},
  { header: 'Battery Install Date Str4 Bat2', key: 'installDate42',  width:wchinstallDate42},
  { header: 'Battery Install Date Str4 Bat3', key: 'installDate43',  width:wchinstallDate43},
  { header: 'Battery Install Date Str4 Bat4', key: 'installDate44',  width:wchinstallDate44},
  { header: 'Battery Install Date Str5 Bat1', key: 'installDate51',  width:wchinstallDate51},
  { header: 'Battery Install Date Str5 Bat2', key: 'installDate52',  width:wchinstallDate52},
  { header: 'Battery Install Date Str5 Bat3', key: 'installDate53',  width:wchinstallDate53},
  { header: 'Battery Install Date Str5 Bat4', key: 'installDate54',  width:wchinstallDate54},
  { header: 'Battery Install Date Str6 Bat1', key: 'installDate61',  width:wchinstallDate61},
  { header: 'Battery Install Date Str6 Bat2', key: 'installDate62',  width:wchinstallDate62},
  { header: 'Battery Install Date Str6 Bat3', key: 'installDate63',  width:wchinstallDate63},
  { header: 'Battery Install Date Str6 Bat4', key: 'installDate64',  width:wchinstallDate64},
  { header: 'Battery Voltage No Load Str1 Bat1', key: 'voltage11',  width:wchvoltage11},
  { header: 'Battery Voltage No Load Str1 Bat2', key: 'voltage12',  width:wchvoltage12},
  { header: 'Battery Voltage No Load Str1 Bat3', key: 'voltage13',  width:wchvoltage13},
  { header: 'Battery Voltage No Load Str1 Bat4', key: 'voltage14',  width:wchvoltage14},
  { header: 'Battery Voltage No Load Str2 Bat1', key: 'voltage21',  width:wchvoltage21},
  { header: 'Battery Voltage No Load Str2 Bat2', key: 'voltage22',  width:wchvoltage22},
  { header: 'Battery Voltage No Load Str2 Bat3', key: 'voltage23',  width:wchvoltage23},
  { header: 'Battery Voltage No Load Str2 Bat4', key: 'voltage24',  width:wchvoltage24},
  { header: 'Battery Voltage No Load Str3 Bat1', key: 'voltage31',  width:wchvoltage31},
  { header: 'Battery Voltage No Load Str3 Bat2', key: 'voltage32',  width:wchvoltage32},
  { header: 'Battery Voltage No Load Str3 Bat3', key: 'voltage33',  width:wchvoltage33},
  { header: 'Battery Voltage No Load Str3 Bat4', key: 'voltage34',  width:wchvoltage34},
  { header: 'Battery Voltage No Load Str4 Bat1', key: 'voltage41',  width:wchvoltage41},
  { header: 'Battery Voltage No Load Str4 Bat2', key: 'voltage42',  width:wchvoltage42},
  { header: 'Battery Voltage No Load Str4 Bat3', key: 'voltage43',  width:wchvoltage43},
  { header: 'Battery Voltage No Load Str4 Bat4', key: 'voltage44',  width:wchvoltage44},
  { header: 'Battery Voltage No Load Str5 Bat1', key: 'voltage51',  width:wchvoltage51},
  { header: 'Battery Voltage No Load Str5 Bat2', key: 'voltage52',  width:wchvoltage52},
  { header: 'Battery Voltage No Load Str5 Bat3', key: 'voltage53',  width:wchvoltage53},
  { header: 'Battery Voltage No Load Str5 Bat4', key: 'voltage54',  width:wchvoltage54},
  { header: 'Battery Voltage No Load Str6 Bat1', key: 'voltage61',  width:wchvoltage61},
  { header: 'Battery Voltage No Load Str6 Bat2', key: 'voltage62',  width:wchvoltage62},
  { header: 'Battery Voltage No Load Str6 Bat3', key: 'voltage63',  width:wchvoltage63},
  { header: 'Battery Voltage No Load Str6 Bat4', key: 'voltage64',  width:wchvoltage64},
  { header: 'Battery Voltage Under Load Str1 Bat1', key: 'batteryVoltageUnderload11',  width:wchbatteryVoltageUnderload11},
  { header: 'Battery Voltage Under Load Str1 Bat2', key: 'batteryVoltageUnderload12',  width:wchbatteryVoltageUnderload12},
  { header: 'Battery Voltage Under Load Str1 Bat3', key: 'batteryVoltageUnderload13',  width:wchbatteryVoltageUnderload13},
  { header: 'Battery Voltage Under Load Str1 Bat4', key: 'batteryVoltageUnderload14',  width:wchbatteryVoltageUnderload14},
  { header: 'Battery Voltage Under Load Str2 Bat1', key: 'batteryVoltageUnderload21',  width:wchbatteryVoltageUnderload21},
  { header: 'Battery Voltage Under Load Str2 Bat2', key: 'batteryVoltageUnderload22',  width:wchbatteryVoltageUnderload22},
  { header: 'Battery Voltage Under Load Str2 Bat3', key: 'batteryVoltageUnderload23',  width:wchbatteryVoltageUnderload23},
  { header: 'Battery Voltage Under Load Str2 Bat4', key: 'batteryVoltageUnderload24',  width:wchbatteryVoltageUnderload24},
  { header: 'Battery Voltage Under Load Str3 Bat1', key: 'batteryVoltageUnderload31',  width:wchbatteryVoltageUnderload31},
  { header: 'Battery Voltage Under Load Str3 Bat2', key: 'batteryVoltageUnderload32',  width:wchbatteryVoltageUnderload32},
  { header: 'Battery Voltage Under Load Str3 Bat3', key: 'batteryVoltageUnderload33',  width:wchbatteryVoltageUnderload33},
  { header: 'Battery Voltage Under Load Str3 Bat4', key: 'batteryVoltageUnderload34',  width:wchbatteryVoltageUnderload34},
  { header: 'Battery Voltage Under Load Str4 Bat1', key: 'batteryVoltageUnderload41',  width:wchbatteryVoltageUnderload41},
  { header: 'Battery Voltage Under Load Str4 Bat2', key: 'batteryVoltageUnderload42',  width:wchbatteryVoltageUnderload42},
  { header: 'Battery Voltage Under Load Str4 Bat3', key: 'batteryVoltageUnderload43',  width:wchbatteryVoltageUnderload43},
  { header: 'Battery Voltage Under Load Str4 Bat4', key: 'batteryVoltageUnderload44',  width:wchbatteryVoltageUnderload44},
  { header: 'Battery Voltage Under Load Str5 Bat1', key: 'batteryVoltageUnderload51',  width:wchbatteryVoltageUnderload51},
  { header: 'Battery Voltage Under Load Str5 Bat2', key: 'batteryVoltageUnderload52',  width:wchbatteryVoltageUnderload52},
  { header: 'Battery Voltage Under Load Str5 Bat3', key: 'batteryVoltageUnderload53',  width:wchbatteryVoltageUnderload53},
  { header: 'Battery Voltage Under Load Str5 Bat4', key: 'batteryVoltageUnderload54',  width:wchbatteryVoltageUnderload54},
  { header: 'Battery Voltage Under Load Str6 Bat1', key: 'batteryVoltageUnderload61',  width:wchbatteryVoltageUnderload61},
  { header: 'Battery Voltage Under Load Str6 Bat2', key: 'batteryVoltageUnderload62',  width:wchbatteryVoltageUnderload62},
  { header: 'Battery Voltage Under Load Str6 Bat3', key: 'batteryVoltageUnderload63',  width:wchbatteryVoltageUnderload63},
  { header: 'Battery Voltage Under Load Str6 Bat4', key: 'batteryVoltageUnderload64',  width:wchbatteryVoltageUnderload64},
  { header: 'Battery Conductance Str1 Bat1', key: 'batteryConductance11',  width:wchbatteryConductance11},
  { header: 'Battery Conductance Str1 Bat2', key: 'batteryConductance12',  width:wchbatteryConductance12},
  { header: 'Battery Conductance Str1 Bat3', key: 'batteryConductance13',  width:wchbatteryConductance13},
  { header: 'Battery Conductance Str1 Bat4', key: 'batteryConductance14',  width:wchbatteryConductance14},
  { header: 'Battery Conductance Str2 Bat1', key: 'batteryConductance21',  width:wchbatteryConductance21},
  { header: 'Battery Conductance Str2 Bat2', key: 'batteryConductance22',  width:wchbatteryConductance22},
  { header: 'Battery Conductance Str2 Bat3', key: 'batteryConductance23',  width:wchbatteryConductance23},
  { header: 'Battery Conductance Str2 Bat4', key: 'batteryConductance24',  width:wchbatteryConductance24},
  { header: 'Battery Conductance Str3 Bat1', key: 'batteryConductance31',  width:wchbatteryConductance31},
  { header: 'Battery Conductance Str3 Bat2', key: 'batteryConductance32',  width:wchbatteryConductance32},
  { header: 'Battery Conductance Str3 Bat3', key: 'batteryConductance33',  width:wchbatteryConductance33},
  { header: 'Battery Conductance Str3 Bat4', key: 'batteryConductance34',  width:wchbatteryConductance34},
  { header: 'Battery Conductance Str4 Bat1', key: 'batteryConductance41',  width:wchbatteryConductance41},
  { header: 'Battery Conductance Str4 Bat2', key: 'batteryConductance42',  width:wchbatteryConductance42},
  { header: 'Battery Conductance Str4 Bat3', key: 'batteryConductance43',  width:wchbatteryConductance43},
  { header: 'Battery Conductance Str4 Bat4', key: 'batteryConductance44',  width:wchbatteryConductance44},
  { header: 'Battery Conductance Str5 Bat1', key: 'batteryConductance51',  width:wchbatteryConductance51},
  { header: 'Battery Conductance Str5 Bat2', key: 'batteryConductance52',  width:wchbatteryConductance52},
  { header: 'Battery Conductance Str5 Bat3', key: 'batteryConductance53',  width:wchbatteryConductance53},
  { header: 'Battery Conductance Str5 Bat4', key: 'batteryConductance54',  width:wchbatteryConductance54},
  { header: 'Battery Conductance Str6 Bat1', key: 'batteryConductance61',  width:wchbatteryConductance61},
  { header: 'Battery Conductance Str6 Bat2', key: 'batteryConductance62',  width:wchbatteryConductance62},
  { header: 'Battery Conductance Str6 Bat3', key: 'batteryConductance63',  width:wchbatteryConductance63},
  { header: 'Battery Conductance Str6 Bat4', key: 'batteryConductance64',  width:wchbatteryConductance64},
  { header: 'Battery Cond - Corrected to 77 deg F Str1 Bat1', key: 'batteryConductanceCorrected11',  width:wchbatteryConductanceCorrected11},
  { header: 'Battery Cond - Corrected to 77 deg F Str1 Bat2', key: 'batteryConductanceCorrected12',  width:wchbatteryConductanceCorrected12},
  { header: 'Battery Cond - Corrected to 77 deg F Str1 Bat3', key: 'batteryConductanceCorrected13',  width:wchbatteryConductanceCorrected13},
  { header: 'Battery Cond - Corrected to 77 deg F Str1 Bat4', key: 'batteryConductanceCorrected14',  width:wchbatteryConductanceCorrected14},
  { header: 'Battery Cond - Corrected to 77 deg F Str2 Bat1', key: 'batteryConductanceCorrected21',  width:wchbatteryConductanceCorrected21},
  { header: 'Battery Cond - Corrected to 77 deg F Str2 Bat2', key: 'batteryConductanceCorrected22',  width:wchbatteryConductanceCorrected22},
  { header: 'Battery Cond - Corrected to 77 deg F Str2 Bat3', key: 'batteryConductanceCorrected23',  width:wchbatteryConductanceCorrected23},
  { header: 'Battery Cond - Corrected to 77 deg F Str2 Bat4', key: 'batteryConductanceCorrected24',  width:wchbatteryConductanceCorrected24},
  { header: 'Battery Cond - Corrected to 77 deg F Str3 Bat1', key: 'batteryConductanceCorrected31',  width:wchbatteryConductanceCorrected31},
  { header: 'Battery Cond - Corrected to 77 deg F Str3 Bat2', key: 'batteryConductanceCorrected32',  width:wchbatteryConductanceCorrected32},
  { header: 'Battery Cond - Corrected to 77 deg F Str3 Bat3', key: 'batteryConductanceCorrected33',  width:wchbatteryConductanceCorrected33},
  { header: 'Battery Cond - Corrected to 77 deg F Str3 Bat4', key: 'batteryConductanceCorrected34',  width:wchbatteryConductanceCorrected34},
  { header: 'Battery Cond - Corrected to 77 deg F Str4 Bat1', key: 'batteryConductanceCorrected41',  width:wchbatteryConductanceCorrected41},
  { header: 'Battery Cond - Corrected to 77 deg F Str4 Bat2', key: 'batteryConductanceCorrected42',  width:wchbatteryConductanceCorrected42},
  { header: 'Battery Cond - Corrected to 77 deg F Str4 Bat3', key: 'batteryConductanceCorrected43',  width:wchbatteryConductanceCorrected43},
  { header: 'Battery Cond - Corrected to 77 deg F Str4 Bat4', key: 'batteryConductanceCorrected44',  width:wchbatteryConductanceCorrected44},
  { header: 'Battery Cond - Corrected to 77 deg F Str5 Bat1', key: 'batteryConductanceCorrected51',  width:wchbatteryConductanceCorrected51},
  { header: 'Battery Cond - Corrected to 77 deg F Str5 Bat2', key: 'batteryConductanceCorrected52',  width:wchbatteryConductanceCorrected52},
  { header: 'Battery Cond - Corrected to 77 deg F Str5 Bat3', key: 'batteryConductanceCorrected53',  width:wchbatteryConductanceCorrected53},
  { header: 'Battery Cond - Corrected to 77 deg F Str5 Bat4', key: 'batteryConductanceCorrected54',  width:wchbatteryConductanceCorrected54},
  { header: 'Battery Cond - Corrected to 77 deg F Str6 Bat1', key: 'batteryConductanceCorrected61',  width:wchbatteryConductanceCorrected61},
  { header: 'Battery Cond - Corrected to 77 deg F Str6 Bat2', key: 'batteryConductanceCorrected62',  width:wchbatteryConductanceCorrected62},
  { header: 'Battery Cond - Corrected to 77 deg F Str6 Bat3', key: 'batteryConductanceCorrected63',  width:wchbatteryConductanceCorrected63},
  { header: 'Battery Cond - Corrected to 77 deg F Str6 Bat4', key: 'batteryConductanceCorrected64',  width:wchbatteryConductanceCorrected64},
  { header: 'Total String voltage Str1 Bat1', key: 'totalVoltageString11',  width:wchtotalVoltageString11},
  { header: 'Total String voltage Str1 Bat2', key: 'totalVoltageString12',  width:wchtotalVoltageString12},
  { header: 'Total String voltage Str2 Bat1', key: 'totalVoltageString21',  width:wchtotalVoltageString21},
  { header: 'Total String voltage Str2 Bat2', key: 'totalVoltageString22',  width:wchtotalVoltageString22},
  { header: 'Total String voltage Str3 Bat1', key: 'totalVoltageString31',  width:wchtotalVoltageString31},
  { header: 'Total String voltage Str3 Bat2', key: 'totalVoltageString32',  width:wchtotalVoltageString32},
  { header: 'Total String voltage Str4 Bat1', key: 'totalVoltageString41',  width:wchtotalVoltageString41},
  { header: 'Total String voltage Str4 Bat2', key: 'totalVoltageString42',  width:wchtotalVoltageString42},
  { header: 'Total String voltage Str5 Bat1', key: 'totalVoltageString51',  width:wchtotalVoltageString51},
  { header: 'Total String voltage Str5 Bat2', key: 'totalVoltageString52',  width:wchtotalVoltageString52},
  { header: 'Total String voltage Str5 Bat3', key: 'totalVoltageString53',  width:wchtotalVoltageString53},
  { header: 'Total String voltage Str5 Bat4', key: 'totalVoltageString54',  width:wchtotalVoltageString54},
  { header: 'Total String voltage Str6 Bat1', key: 'totalVoltageString61',  width:wchtotalVoltageString61},
  { header: 'Total String voltage Str6 Bat2', key: 'totalVoltageString62',  width:wchtotalVoltageString62},
  { header: 'Total String voltage Str6 Bat3', key: 'totalVoltageString63',  width:wchtotalVoltageString63},
  { header: 'Total String voltage Str6 Bat4', key: 'totalVoltageString64',  width:wchtotalVoltageString64},
  { header: 'Battery Comments', key: 'batteryComments',width:wchbatteryComments },
  //APU
  { header: 'APU - Make Model', key: 'apuMakeModel',  width:wchapuMakeModel},
  { header: 'APU Serial number', key: 'apuSerialNumber',  width:wchapuSerialNumber},
  { header: 'APU Device Id', key: 'apuDeviceId',  width:wchapuDeviceId},
  { header: 'APU Runtime', key: 'apuRunTime',  width:wchapuRunTime},
  { header: 'ECM/ACM', key: 'ecmAcm',  width:wchecmAcm},
  { header: 'APU Install Date', key: 'dateApuInstalledValue',  width:wchdateApuInstalledValue},
  { header: 'APU Output Voltage Rating', key: 'apuOutputVoltageRating',  width:wchapuOutputVoltageRating},
  { header: 'APU No Load Voltage', key: 'apuNoLoadVoltage',  width:wchapuNoLoadVoltage},
  { header: 'APU Load Voltage', key: 'apuLoadVoltage',width:wchapuLoadVoltage},
  { header: 'APU Enclosure Make/model', key: 'apuEnclosureMake',  width:wchapuEnclosureMake},
  { header: 'NG/LP', key: 'ngLp',  width:wchngLp},
  { header: 'NG Provider', key: 'ngProvider',  width:wchngProvider},
  { header: 'LP Tank Capacity', key: 'lpTankCapacity',  width:wchlpTankCapacity},
  { header: 'Number of Tanks Installed', key: 'numberTanksInstalled',  width:wchnumberTanksInstalled},

  //APU Inspection
  { header: 'APU Inspection date', key: 'inspectionDateValue',  width:wchinspectionDateValue},
  { header: 'Tech Info', key: 'technicianNtUserName',  width:wchtechnicianNtUserName },

  //APU Inspection Battery
  { header: 'APU Battery Manufacturer type', key: 'apuBatteryManufacturerType',  width:wchapuBatteryManufacturerType},
  { header: 'APU Battery install date', key: 'apuBatteryInstallDateValue',  width:wchapuBatteryInstallDateValue},
  { header: 'APU Battery voltage - No Load', key: 'apuBatteryVoltageNoLoad',  width:wchapuBatteryVoltageNoLoad},
  { header: 'APU Battery Conductance - mhos', key: 'apuBatteryConductance',  width:wchapuBatteryConductance},
  { header: 'APU Battery Conductance - Corrected o 77 deg. F', key: 'apuBatteryConductanceCrrctd',  width:wchapuBatteryConductanceCrrctd},
  { header: 'APU Battery Torque in LBs', key: 'apuBatteryTorque',  width:wchapuBatteryTorque},
  { header: 'APU Battery terminals cleaned?', key: 'apuBatteryTerminalsCleaned',  width:wchapuBatteryTerminalsCleaned},
  { header: 'APU Starter battery charger voltage', key: 'apuStarterBatteryChrgrVlt',  width:wchapuStarterBatteryChrgrVlt},
  { header: 'APU Charge current', key: 'apuChargerCurrentAmps',  width:wchapuChargerCurrentAmps},
  { header: 'Follow Up Action Needed', key: 'followUpNededAPU',  width:wchfollowUpNeededAPU},
  { header: 'Record as found alarms', key: 'recordAsFoundAlarms',  width:wchrecordAsFoundAlarms},

  //APU Info
  { header: 'APU test run (10min under load)', key: 'apuTestRun',  width:wchapuTestRun},
  { header: 'Check Oil Level', key: 'checkOilLevel',  width:wchcheckOilLevel},
  { header: 'If Oil added amount', key: 'oilAddedAmount',  width:wchoilAddedAmount},
  { header: 'Oil filter tight', key: 'oilFilterTight',  width:wchoilFilterTight},
  { header: 'Inspect Generator Air Filter', key: 'inspectGeneratorAirFilter',  width:wchinspectGeneratorAirFilter},
  { header: 'Inspect Spark Plug', key: 'inspectSparkPlug',  width:wchinspectSparkPlug},
  { header: 'Clear APU Event Log', key: 'clearApuEventLog',  width:wcheventLogCleared},
  { header: 'APU Frequency (HZ)', key: 'apuFrequency',  width:wchapuFrequency},
  { header: 'Tank #1 (Level - if LP)', key: 'tankOneLevel',  width:wchtankOneLevel},
  { header: 'Tank #2 (Level - if LP)', key: 'tankTwoLevel',  width:wchtankTwoLevel},
  { header: 'Gas # Meter (if NG Gas)', key: 'gasMeterNumber',  width:wchgasMeterNumber},
  { header: 'Gas Meter Reading (if NG Gas)', key: 'gasMeterReading',  width:wchgasMeterReading},
  { header: 'NG Pressure', key: 'ngPressure',  width:wchngPressure},

  //APU Inspection-Enclosure/PAD
  { header: 'Change/Clean enclosure air filter', key: 'changeCleanenClosureAirFilter',  width:wchchangeCleanenClosureAirFilter},
  { header: 'Check for Rodent Damage', key: 'checkForRodentDamage',  width:wchcheckForRodentDamage},
  { header: 'Check Lamps & LED', key: 'checkLampsLed',  width:wchcheckLampsLed},
  { header: 'Clear weeds back 36 Inches if ground mount unit', key: 'clearWeeds',  width:wchclearWeeds},
  { header: 'Check & re-grout pad conduit openings as needed', key: 'checkRegroutPadConduit',  width:wchcheckRegroutPadConduit},
  { header: 'If Ground Mount Any pad undermining', key: 'groundMountPadUndermining',  width:wchgroundMountPadUndermining},
  { header: 'Any enclosure damage or Vandalism', key: 'enclosureDamageVandalism',  width:wchenclosureDamageVandalism},
  { header: 'Clean up garbage with in immediate vicinity', key: 'cleanupGarbage',  width:wchcleanupGarbage},
  { header: 'Test Oil pressure alarm', key: 'testOilPressureAlarm',  width:wchtestOilPressureAlarm},
  { header: 'Test High Temperature Alarm', key: 'testHighTempAlarm',  width:wchtestHighTempAlarm},
  { header: 'Generator DC Bus function', key: 'generatorDcBusFunction',  width:wchgeneratorDcBusFunction},
  { header: 'Check for gas leaks', key: 'checkForGasLeaks',  width:wchcheckForGasLeaks},
  { header: 'Test Combustible Gas Alarm', key: 'testCombustibleGasAlarm',  width:wchtestCombustibleGasAlarm},
  { header: 'Test Tamper alarm', key: 'testTamperAlarm',  width:wchtestTamperAlarm},
  { header: 'If ground mount Test Water Intrusion Alarm', key: 'testWaterIntrusionAlarm',  width:wchtestWaterIntrusionAlarm},
  { header: 'If ground mount Test Pad Shear Alarm', key: 'testPadShearAlarm',  width:wchtestPadShearAlarm},
  { header: 'APU Visit Comments', key: 'apuVisitComments',  width:wchapuVisitComments},

  //LAst Visit Inspection
  { header: 'Last Visit Inspection Date', key: 'inspectionDatelastvisit',  width:wchinspectionDatelastvisit},
  { header: 'Type of Visit', key: 'typeOfVisit',  width:wchtypeofvisit},
  { header: 'Visit Status', key: 'visitStatus',  width:wchvisitStatus},
  { header: 'Followup Reason', key: 'followUpReason',  width:wchfollowUpReason},
  { header: 'XOC Verified Transponder Operational', key: 'xocVerified',  width:wchxocVerified},
  { header: 'Clean Dust And Dirt From Enclosure', key: 'cleanEnclosure',  width:wchcleanEnclosure},
  { header: 'Tighten All Enclosure Hardware', key: 'tightenHardware',  width:wchtightenHardware},
  { header: 'Inspect Wire Harnesses And Connectors', key: 'inspectConnectors',  width:wchinspectConnectors},
  { header: 'Inspect Battery Temperature Probes', key: 'inspectProbes',  width:wchinspectProbes},
  { header: 'Meter Pan Condition:', key: 'meterPanCondition',  width:wchmeterPanCondition},
  { header: 'Power Co Riser Condition', key: 'powerCoRiserCondition',  width:wchpowerCoRiserCondition},
  { header: 'Battery Heater Mat Type', key: 'batteryHeaterMatType',  width:wchbatteryHeaterMatType},
  { header: 'Battery Heater Mat Quantity', key: 'batteryHeaterMatQuantity',  width:wchbatteryHeaterMatQuantity},
  { header: 'Enclosure snow shield', key: 'enclosureSnowShield',  width:wchenclosureSnowShield},
  { header: 'Internal Breaker', key: 'internalBreaker',  width:wchinternalBreaker},
  { header: 'Service Entrance', key: 'serviceEntrance',  width:wchserviceEntrance},
  { header: 'Receptacle type', key: 'receptacleType',  width:wchreceptacleType},
  { header: 'Check Seizure screw/alt box', key: 'checkSeizureAltBox',  width:wchcheckSeizureAltBox},
  { header: 'Is Power Supply ID Legible', key: 'powerSupplyIdLegible',  width:wchpowerSupplyIdLegible},
  { header: 'Check Lamps & LEDs', key: 'checkLampsLeds',  width:wchcheckLampsLeds},
  { header: 'Check For 20 Amp Hi-Magnetic Circuit Breaker', key: 'checkMagneticBreaker',  width:wchcheckMagneticBreaker},
  { header: 'Visual Inspection Of Cabinet', key: 'visualCabinetInspection',  width:wchvisualCabinetInspection},
  { header: 'Cabinet Locked', key: 'cabinetLocked',  width:wchcabinetLocked},
  { header: 'Security Bar Present', key: 'securityBarPresent',width: wchsecurityBarPresent },
  { header: 'Check Ground Connection At Cabinet', key: 'checkGroundCabinet',  width:wchcheckGroundCabinet},
  { header: 'Tamper Installed and functioning', key: 'tamperInstalledFunctioning',  width:wchtamperInstalledFunctioning},
  { header: 'Check LAPs', key: 'checkLaps',  width:wchcheckLaps},
  { header: 'Cabinet Vendor', key: 'cabinetVendor',  width:wchcabinetVendor},
  { header: 'Cabinet Battery Capacity', key: 'cabinetBatteryCapacity',  width:wchcabinetBatteryCapacity},
  { header: 'Check Operating Lights', key: 'checkOperatingLights',  width:wchcheckOperatingLights},
  { header: 'Follow Up Action Needed', key: 'followUpNeeded',  width:wchfollowUpNeeded},
  { header: 'Stand By Operation', key: 'standByOperation',  width:wchstandByOperation},
  { header: 'Input Surge Arrestor', key: 'inputSurgeArrestor',  width:wchinputSurgeArrestor},
  { header: 'Output Surge Arrestor', key: 'outputSurgeArrestor',  width:wchoutputSurgeArrestor},
  { header: 'COAX TVSS Present', key: 'coaxTvssPresent',  width:wchcoaxTvssPresent},
  { header: 'AC Indicator Green light (ACI)', key: 'acIndicatorGreenLight',  width:wchacIndicatorGreenLight},
  { header: 'Local and Remote Indicator (LRI)', key: 'localRemoteIndicator',  width:wchlocalRemoteIndicator},
  { header: 'Tech', key: 'technicianNtUserName',  width:wchcommTech},
  { header: 'Last Visit Comments', key: 'comments',  width:wchcomments},

  //WorkItems
  { header: 'WorkItem1', key: 'workitem1',  width:wchwrkitem},
  { header: 'WorkDescription1', key: 'workDescription1',  width:wchwrkitem},
  { header: 'Quantity1', key: 'quantity1',  width:wchqnty},
  { header: 'WorkItem2', key: 'workitem2',  width:wchwrkitem},
  { header: 'WorkDescription2', key: 'workDescription2',  width:wchwrkitem},
  { header: 'Quantity2', key: 'quantity2',  width:wchqnty},
  { header: 'WorkItem3', key: 'workitem3',  width:wchwrkitem},
  { header: 'WorkDescription3', key: 'workDescription3',  width:wchwrkitem},
  { header: 'Quantity3', key: 'quantity3',  width:wchqnty},
  { header: 'WorkItem4', key: 'workitem4',  width:wchwrkitem},
  { header: 'WorkDescription4', key: 'workDescription4',  width:wchwrkitem},
  { header: 'Quantity4', key: 'quantity4',  width:wchqnty},
  { header: 'WorkItem5', key: 'workitem5',  width:wchwrkitem},
  { header: 'WorkDescription5', key: 'workDescription5',  width:wchwrkitem},
  { header: 'Quantity5', key: 'quantity5',  width:wchqnty},

  { header: 'MaterialType1', key: 'materialType1',  width:wchmaterialType},
  { header: 'MaterialmodelDescription1', key: 'modelDescription1',  width:wchmodelDescription},
  { header: 'Materialmodel1', key: 'model1',  width:wchmodel},
  { header: 'Quantity1', key: 'matquantity1',  width:wchquantity},

  { header: 'MaterialType2', key: 'materialType2',  width:wchmaterialType},
  { header: 'MaterialmodelDescription2', key: 'modelDescription2',  width:wchmodelDescription},
  { header: 'Materialmodel2', key: 'model2',  width:wchmodel},
  { header: 'Quantity2', key: 'matquantity2',  width:wchquantity},

  { header: 'MaterialType3', key: 'materialType3',  width:wchmaterialType},
  { header: 'MaterialmodelDescription3', key: 'modelDescription3',  width:wchmodelDescription},
  { header: 'Materialmodel3', key: 'model3',  width:wchmodel},
  { header: 'Quantity3', key: 'matquantity3',  width:wchquantity},

  { header: 'MaterialType4', key: 'materialType4',  width:wchmaterialType},
  { header: 'MaterialmodelDescription4', key: 'modelDescription4',  width:wchmodelDescription},
  { header: 'Materialmodel4', key: 'model4',  width:wchmodel},
  { header: 'Quantity4', key: 'matquantity4',  width:wchquantity},

  { header: 'MaterialType5', key: 'materialType5',  width:wchmaterialType},
  { header: 'MaterialmodelDescription5', key: 'modelDescription5',  width:wchmodelDescription},
  { header: 'Materialmodel5', key: 'model5',  width:wchmodel},
  { header: 'Quantity5', key: 'matquantity5',  width:wchquantity},

  //Photos
  { header: '1. 25’ away from PS showing general surroundings of PS', key: 'catDate1',width: wchphotouploadeddate },
  { header: '2. Before maintenance starts, show open door view of PS and all batteries	', key: 'catDate2',width: wchphotouploadeddate },
  { header: '3. Picture of PS display of MAC', key: 'catDate3',width: wchphotouploadeddate },
  { header: '4. If no display is available or it’s an External Transponder, picture of sticker', key: 'catDate4',width: wchphotouploadeddate},
  { header: '5. Picture of string of batteries that shows separation, wiring and Temp probe', key: 'catDate5',width: wchphotouploadeddate },
  { header: '6. Battery date stamp', key: 'catDate6',width: wchphotouploadeddate },
  { header: '7. Coaxial ground block in PS cabinet to include input RF', key: 'catDate7',width: wchphotouploadeddate },
  { header: '8. PS ground', key: 'catDate8',width: wchphotouploadeddate },
  { header: '9. Commercial power outlet showing LAP and PS connector', key: 'catDate9',width: wchphotouploadeddate },
  { header: '10. Repeat step 2 after work is completed', key: 'catDate10',width: wchphotouploadeddate },
  { header: '11. Power Company Electric Meter', key: 'catDate11',width: wchphotouploadeddate },

  //Alarms
  { header: 'Alert', key: 'alertLevel',  width:wchalertLevel},
  { header: 'Warning', key: 'warning',  width:wchwarning},
  { header: 'Informational', key: 'informational',  width:wchinformational},

  //Technician Info
  { header: 'Technician Name', key: 'technicianName',  width:wchtechnicianName},
  { header: 'Technician Phone Number', key: 'technicianNumber',  width:wchtechnicianNumber},

  //Telemetry Info
  { header: 'SysDesc', key: 'sysDescr',  width:wchsysDescr},
  { header: 'BootR', key: 'bootR',  width:wchbootR},
  { header: 'ConfigFile', key: 'configFile',  width:wchconfigFile},
  { header: 'HwRev', key: 'hwRev',  width:wchhwRev},
  { header: 'SwRev', key: 'swRev',  width:wchswRev},
  { header: 'Bootfile', key: 'bootfile',  width:wchbootfile},
  { header: 'SysName', key: 'sysName',  width:wchsysName},
  { header: 'Ethernet Connected Device', key: 'externalSensor',  width:wchexternalSensor},

  //selftest info
  // { header: 'Last Run Status', key: 'lastrunstatus',  width:wchstatus},
  // { header: 'Test Duration', key: 'testduration',  width:wchtestduration},
  // { header: 'Test Start Date', key: 'teststartdate',  width:wchteststartdate},
  // { header: 'Test End Date', key: 'testenddate',  width:wchtestenddate},
 ];
}
}
